module.exports = __webpack_public_path__ + "img/ultimate-guide-to-natural-language-processing-courses.1769f196.png";